import { IPricingItem } from './pricing-item.model';
import { ISpecialPlacePricingItem } from './special-place-pricing-item.model';

export class EligiblePricingItems {
  constructor(public pricingItems: IPricingItem[], public specialPlacePricingItems: ISpecialPlacePricingItem[], public transporterDefaultMarginRate: number) {}
}
